export const globalState = {
    isEditorView: false,
};

export default globalState;
